import { render, staticRenderFns } from "./ObserveListDetailsSection.vue?vue&type=template&id=612f1e50"
import script from "./ObserveListDetailsSection.vue?vue&type=script&lang=js"
export * from "./ObserveListDetailsSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports